import { isLoggedIn } from "@shapr3d/frontend-lib";
import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";

const NavigateToAccountWhenLoggedIn: React.FC<{ children: ReactNode }> = ({ children }) => {
  if (isLoggedIn()) {
    return <Navigate to="/account" replace={true} />;
  }

  return <>{children}</>;
};

export default NavigateToAccountWhenLoggedIn;
